module.exports = __webpack_public_path__ + "img/mobile-network-sdk.36de33a.png";